import Tile from './tile';
import './tiles.scss';

function Tiles({ tiles = [], col = 3, selectedId, onSelect }) {
  return (
    <div className={`tiles tiles-col-${col}`}>
      {tiles.map((tile) => {
        return <Tile key={tile.id} tile={tile} selected={selectedId === tile.id} onClick={onSelect} />;
      })}
    </div>
  );
}

export default Tiles;
